import React, { forwardRef } from 'react';
import styled from 'styled-components';
import SearchBarWithHistoryAndSuggestion from '../../search/searchBar/SearchBarWithHistoryAndSuggestion';
import breakpoints from '../../../config/Breakpoints';
import SearchHistoryResponse from '../../../common/response/SearchHistoryResponse';
import { SearchBarHandle } from '../../search/searchBar/SearchBar';

const IndexSearchBar = forwardRef<SearchBarHandle>((_, ref) => {
    return (
        <Container>
            <SearchBarContainer>
                <SearchBarWithHistoryAndSuggestion
                    ref={ref}
                    autoCompleteApiUrl={`/v1/book/search/auto-complete?types=BOOK,AUTHOR`}
                    searchHistoryApiUrl={`/v2/book/search/histories`}
                    searchResultUrl={'/search'}
                    searchHistoryCacheKey={'search-book-histories'}
                    placeholder={'여러곳에서 한 번에 책 검색하기'}
                    isHandleSubmit={false}
                    isShouldUpdateQueryParam={false}
                    mapSearchHistoryResponse={(data: any[]): SearchHistoryResponse[] =>
                        data.map((d, i) => ({
                            id: i + 1,
                            query: d.title,
                            date: new Date(),
                            url: `/book/${d.isbn}?q=${d.title}`,
                            imageUrl: d.coverUrl,
                            isbn: d.isbn,
                        }))
                    }
                />
            </SearchBarContainer>
        </Container>
    )
})

const Container = styled.div`
    display: flex;
    justify-content: center;
`;

const SearchBarContainer = styled.div`
    width: 50%;

    @media screen and (max-width: ${breakpoints.md}) {
        width: 100%;
    }
`;

export default IndexSearchBar
